module.exports = __webpack_public_path__ + "static/media/phone.8720bb5d.png";